export default [
    {
        path: 'reimpressao-protocolo',
        component: () => import(
            '@/views/transporte-paciente/reimpressao-protocolo/Index'
        ),
        redirect: 'reimpressao-protocolo/list',
        children: [
            {
                name: 'transporte-paciente-reimpressao-protocolo-list',
                path: 'list',
                component: () => import(
                    '@/views/transporte-paciente/reimpressao-protocolo/List'
                ),
            },
        ],
    },
]